"use client";

import Analytics from "@/app/_components/analytics";
import { Layout } from "@/components";
import { GamePageLayout } from "@/components/NewGamePage/GamePageLayout";
import { ImageBackground } from "@/components/ui/custom/image-background";
import { GameDetailsProvider } from "../../../../context/GameDetailsContext";
import GameDetailsV2 from "../game-details-v2";
import type { GameData } from "../types";

export const SubscribedLayout = ({ gameData }: { gameData: GameData }) => {
  if (gameData.gameContent?.is_prelaunch) {
    // v3
    return (
      <Layout disableContainerPadding hideRightNav>
        <GameDetailsProvider gameData={gameData}>
          <GamePageLayout gameData={gameData} />
        </GameDetailsProvider>
      </Layout>
    );
  }

  return (
    // v2
    <Layout disableContainerPadding>
      {!!gameData.details.background_url && (
        <ImageBackground
          staticImageUrl={gameData.details.background_url}
          className="absolute inset-0"
          priority={true}
        />
      )}
      <Analytics screen="Details" userJourney="Games" />
      <GameDetailsV2 gameData={gameData} />
    </Layout>
  );
};
